import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Advantages from './components/Advantages';
import Location from './components/Location';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Header from './components/Header';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <About />
      <Advantages />
      <Location />
      <CTA />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
